/**
 * @memberof generateSchema
 * */
export const gatherAllFormFields = (formElement: HTMLFormElement | null) => {
    return Array.from(formElement?.elements ?? [])
}
